export const onEnterSpace = (fn) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') fn(e);
};
